<template>
  <div id="messages-filter">
    <f7-list>
      <!-- Boutons de sélection/sauvegarde/suppression/application du filtre -->
      <f7-list-item :class="additionalClass">
        <span class="sr-only">{{ $t('common.list_actions') }}</span>

        <b-row class="justify-content-start no-gutter w-100">
          <!-- Left section filtre -->
          <div class="form-group mr-2">
            <b-button class="btnFilter"
              :aria-label="$t('common.rfrsh')"
              @click="$emit('refreshInbox')">
              <i class="fa fa-rotate-right fs-14px"></i>
            </b-button>
          </div>
          <!-- Right section filtre -->
          <div class="form-group mx-2" v-if="mode != 5">
            <b-button class="btnFilter_2"
              @click="$emit('extractCSV')">
              <i class="fa-light fa-upload fs-14px"></i>
              <span class="fab-label">{{ $t('common.extract_list') }}</span>
            </b-button>
          </div>
          <div class="form-group mx-2" v-if="mode != 5">
            <b-button-group class="mt-sm-0">
              <b-button :variant="role === 2 ? 'primary' : ''" @click="role = 2">{{ $t('common.all') }}</b-button>
              <b-button :variant="role === 1 ? 'primary' : ''" @click="role = 1">{{ $t('common.sent') }}</b-button>
              <b-button :variant="role === 0 ? 'primary' : ''" @click="role = 0">{{ $t('common.received') }}</b-button>
            </b-button-group>
          </div>
          <div class="form-group mx-2" v-if="mode === 5">
            <b-button-group class="mt-sm-0">
              <b-button v-if="hasInbound" :variant="section === 1 ? 'primary' : ''" @click="section = 1;applyFilter(5)">{{ $t('filter.feature.inbound') }}</b-button>
              <b-button v-if="hasOutbound" :variant="section === 2 ? 'primary' : ''" @click="section = 2;applyFilter(5)">{{ $t('filter.feature.outbound') }}</b-button>
            </b-button-group>
          </div>
          <b-col cols="1" class="p-0" offset="3" v-if="showListGroupPanel() && hasRight('rtp_group_create')">
            <b-button variant="primary" size="sm"
              :class='modeFilter === 1 ? "navbar-button-selected": "navbar-button"'
              @click="applyFilter(1)">
              {{ $t('filter.tab_unit') }}
            </b-button>
          </b-col>
          <b-col cols="1" class="p-0" v-if="showListGroupPanel() && hasRight('rtp_group_create')">
            <b-button variant="primary" size="sm"
              :class='modeFilter === 2 ? "navbar-button-selected": "navbar-button"'
              @click="applyFilter(2)">
              {{ $t('filter.tab_group') }}
            </b-button>
          </b-col>
          <b-col cols="2" v-if="showButtonCreateSupplier()">
            <b-button variant="primary" class="btnFilter_2"
              @click="$emit('createSupplier')">
              <i class="fa-light fa-plus fs-14px"></i>
              <span class="fab-label">{{ $t('suppliers.sup') }}</span>
            </b-button>
          </b-col>
          <b-col cols="12" sm="5" md="4" xl="4" v-if="showButtonCreateVerify()" offset="0">
            <b-button variant="primary" class="btnFilter_2 mt-3 mt-xl-0"
              @click="$emit('createVerify')">
              <i class="fa-light fa-plus fs-14px"></i>
              <span class="fab-label">{{ $t('verifications.verify') }}</span>
            </b-button>
          </b-col>
          <b-col cols="2" class="showLargeScreenOnly" v-if="showButtonImportLot()">
            <b-button class="btnFilter"
              @click="$emit('refreshInbox')">
              <i f7="fa-light fa-upload fs-14px"></i>
              <span class="fab-label">{{ $t('common.imprt_list') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </f7-list-item>
      <!-- Sélection des valeurs de Filtre -->
      <f7-list-item :class="{'filter-item-section':true, 'd-none': !displayFilter}"
        class="showLargeScreenOnly">
        <b-row class="min-w-100">
          <b-row class="min-w-100" v-if="showFilterNorm()">
            <b-col cols="12">
              <!-- Filtre norme -->
              <div class="filter-item col-3 mb-3 text-truncate">
                <span id="norm-select-label" class="filter-item-title text-ellipsis">
                  {{ $t('filter.standard_title') }}
                </span>
                <div class="filter-item-content d-flex pt-2">
                  <select
                      autocomplete="off"
                    id="norm-select"
                    aria-labelledby="norm-select-label"
                    v-model="normId" class="z-2 position-relative cursor fs-14px-important h-100 mw-none select-appearance"
                    :class="{'text-muted': !normId}">
                    <option value="" class="text-muted">{{$t('filter.selected_standard_none')}}</option>
                    <option v-for="norm in normList" :key="'standard-option-' + norm.id + '-' + randomString" :value="norm.id">{{norm.label}}</option>
                  </select>
                </div>
            </div>
          </b-col>
        </b-row>
          <b-col cols="9" class="d-flex row justify-content-start">
            <!-- Filtre d'id du fournisseur (qui s'affiche si la raison sociale est affichée)-->
            <div class="filter-item col-4 mb-3" v-if="showFilterSupplierId() && LMSGsupplierconfig">
              <span class="filter-item-title">
                {{ $t('filter.supplier_id') }}
              </span>
              <span class="filter-item-content">
                <input v-model="filterSupplierId"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': filterSupplierId}"
                  :placeholder="$t('filter.supplier_id')"
                  :aria-label="$t('filter.supplier_id')">
              </span>
            </div>

            <!-- Filtre SIREN du fournisseur -->
            <div class="filter-item col-4 mb-3" v-if="showFilterSupplierSIREN()">
              <span class="filter-item-title">
                {{ $t('common.srn') }}
              </span>
              <span class="filter-item-content">
                <input v-model="filterSiren"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': filterSiren}"
                  :placeholder="$t('common.srn_placeholder_supplier')"
                  :aria-label="$t('common.srn_placeholder_supplier')">
              </span>
            </div>

            <!-- Filtre raison sociale du fournisseur -->
            <div class="filter-item col-4 mb-3" v-if="showFilterSupplierName()">
              <span class="filter-item-title">{{ $t('common.social_reason') }}</span>
              <span class="filter-item-content">
                <input v-model="filterSupplierName"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': filterSupplierName}"
                  :placeholder="$t('filter.social_reason_placeholder')"
                  :aria-label="$t('filter.social_reason_placeholder')">
              </span>
            </div>

            <!-- Type du document -->
            <div class="filter-item col-4 mb-3" v-if="showFilterDoctype()">
              <span class="filter-item-title">{{ 'Type du document' }}</span>
              <span class="filter-item-content d-flex">
                <select autocomplete="off" ref="selectDoctype"
                  v-model="filterDocumentType"
                  class="cursor fs-14px h-auto z-2">
                  <option value=""></option>
                  <option value="IDCARD">Carte d'identité</option>
                  <option value="RIB">RIB</option>
                  <option value="Kbis">Kbis</option>
                </select>
                <i class="fa-light fa-chevron-down cursor ml--20px z-1" size="17px" id="status-chevron">
                </i>
              </span>
            </div>

            <!-- Filtre message ID -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="showFilterMsgId()">
              <span class="filter-item-title text-ellipsis">{{ $t('filter.msgId') }}</span>
              <span class="filter-item-content">
                <input v-model="msgId" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': msgId}"
                  :placeholder="$t('filter.msgId')"
                  :aria-label="$t('filter.msgId')">
              </span>
            </div>

            <!-- Filtre debtor id (debtor IBAN) -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="showFilterDebtorId()">
              <label :for="debtorFilterId" class="filter-item-title text-ellipsis">{{ $t('common.debtor_ibn') }}</label>
              <span class="filter-item-content">
                <input v-model="debtorId" @input="delayApplyFilter(modeFilter)"
                  :id="debtorFilterId"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': debtorId}"
                  :placeholder="$t('common.debtor_ibn')">
              </span>
            </div>

            <div class="filter-item col-4 mb-3 text-truncate" v-if="showFilterStatus() && serviceId !== '1'">
              <span class="filter-item-title text-ellipsis">
                {{ serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label') }}
              </span>
              <a :id="'status-picker-link' + '-' + filterType + '-' + randomString" class="filter-item-content d-flex justify-content-between p-1 pt-2"
                href="#">
                <!-- <i v-if="statusDisplay.icon" :class="statusDisplay.icon"></i> -->
                <span :class="{'filter-item-input-complete':statusDisplay.nb > 0}">{{ statusDisplay.label }}</span>
                <i class="fa-light fa-chevron-down" size="17px" id="status-chevron"></i>
              </a>
              <b-popover :target="'status-picker-link' + '-' + filterType + '-' + randomString"
                :title="$t('filter.selected_status_none')"
                triggers="focus" placement="bottomright">
                <span v-for="(status, index) in statusList" :key="status.name + '-' + index">
                  <b-form-checkbox v-model="status.state"
                    v-if="showStatus(status)"
                    :value="1"
                    :unchecked-value="0">
                    <span>{{ status.label }}</span>
                  </b-form-checkbox>
                </span>
              </b-popover>
            </div>

            <div class="filter-item col-4 mb-3 text-truncate" v-if="showFilterStatusKYC()">
              <span class="filter-item-title ml-2px text-ellipsis">
                {{ serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label') }}
                <span class="color-red">* </span>
              </span>
              <span class="filter-item-content d-flex">
                <select autocomplete="off" id="sel2"
                v-model="status"
                class="cursor fs-13px h-auto z-2 color-grey-span-filterKYC">
                  <option value="">{{ $t('acceptance.select_stat') }}</option>
                  <option v-for="status in statusKYC" :key="status.code" :value="status.code">
                    {{ status.label }}
                  </option>
                </select>
                <i class="fa-light fa-chevron-down cursor ml--20px z-1" size="17px" id="status-chevron-KYC">
                </i>
              </span>
            </div>

            <div class="filter-item col-4 mb-3 text-truncate" v-if="showFilterStatusVerif()">
              <span class="filter-item-title ml-2px text-ellipsis">
                {{ serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label') }}
                <span class="color-red">* </span>
              </span>
              <span class="filter-item-content d-flex">
                <select autocomplete="off" id="sel2"
                v-model="status"
                class="cursor fs-13px h-auto z-2 color-grey-span-filterKYC">
                  <option value="">{{ $t('acceptance.select_stat') }}</option>
                  <option v-for="status in statusVerif" :key="status.code" :value="status.code">
                    {{ status.label }}
                  </option>
                </select>
                <i class="fa-light fa-chevron-down cursor ml--20px z-1" size="17px" id="status-chevron-verif">
                </i>
              </span>
            </div>

            <!-- Filtre contact (nom interlocuteur) -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="showFilterContactName()">
              <span id="debtor-name-label" class="filter-item-title text-ellipsis" >{{ $t('filter.debtor_name') }}</span>
              <span class="filter-item-content">
                <input v-model="cdtrOrDbtrNm" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': cdtrOrDbtrNm}"
                  :placeholder="$t('filter.debtor_name')"
                  :aria-label="$t('filter.debtor_name') + ' (' + $t('common.filter') + ')'">
              </span>
            </div>

            <!-- Filtre statut -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="showFilterStatus() && serviceId === '1'">
              <span class="filter-item-title text-ellipsis">
                {{ serviceId === services.SUPPLIERS ? $t('common.kyc_status') : $t('common.status.status_label') }}
              </span>
              <a :id="'status-picker-link' + '-' + filterType + '-' + randomString" class="filter-item-content d-flex justify-content-between p-1 pt-2"
                href="#">
                <!-- <i v-if="statusDisplay.icon" :class="statusDisplay.icon"></i> -->
                <span :class="'fixed-span-size ' + (statusDisplay.nb > 0 ? 'filter-item-input-complete' : '')">{{ statusDisplay.label }}</span>
                <i class="fa-light fa-chevron-down" size="17px" id="status-chevron-status"></i>
              </a>
              <b-popover :target="'status-picker-link' + '-' + filterType + '-' + randomString"
                :title="$t('filter.selected_status_none')"
                triggers="focus" placement="bottom">
                <div>
                  <span key="allStatus">
                    <b-form-checkbox :checked="allStatus()"
                      @change="checkAllStatus"
                      :value="true"
                      :unchecked-value="false">
                      <span class="font-weight-normal fs-13px">{{ allStatus() ? $t('filter.all_uncheck') : $t('filter.all_check') }}</span>
                    </b-form-checkbox>
                  </span>
                </div>
                <hr class="my-2 mx-m08">
                <div v-for="(categoryStatus, categoryName) in arrayStatusList" :key="'rtp-category-' + categoryName + '-' + randomString">
                  <span class="MoneyRoadcolorBlack">{{ $t('common.status.rtp_categories.' + categoryName) }}</span>
                  <span v-for="(status, index) in statusList" :key="status.id + '-' + index">
                    <b-form-checkbox v-model="status.state" v-if="showStatus(status) && categoryStatus.includes(status.id)"
                      @input="delayApplyFilter(modeFilter)"
                      :value="1"
                      :unchecked-value="0">
                      <span class="font-weight-normal fs-13px">{{ $t('common.status.rtp.' + status.id) }}</span>
                    </b-form-checkbox>
                  </span>
                </div>
              </b-popover>
            </div>

            <!-- Filtre type d'action -->
            <div class="filter-item mb-3" v-if="showFilterTypeAction()">
              <span class="filter-item-title">{{ $t('filter.action_type') }}</span>
              <span class="filter-item-content d-flex">
                <select autocomplete="off" ref="selectTypeAction"
                  v-model="typeAction"
                  class="cursor fs-14px h-auto z-2">
                  <option value="">{{ $t('filter.action_type_choose') }}</option>
                  <option value="CREATE">{{ $t('history.CREATE') }}</option>
                  <option value="DELETE">{{ $t('history.DELETE') }}</option>
                  <option value="MODIFY">{{ $t('history.MODIFY') }}</option>
                  <option value="SEND">{{ $t('history.SEND') }}</option>
                  <option value="CANCEL">{{ $t('history.CANCEL') }}</option>
                  <option value="ACCEPT">{{ $t('history.ACCEPT') }}</option>
                  <option value="REFUSE">{{ $t('history.REFUSE') }}</option>
                  <option value="MODIFY_AND_ACCEPT">{{ $t('history.MODIFY_AND_ACCEPT') }}</option>
                  <option value="ACCEPT_AND_PAY">{{ $t('history.ACCEPT_AND_PAY') }}</option>
                  <option value="PAY">{{ $t('history.PAY') }}</option>
                  <option value="SAVE">{{ $t('history.SAVE') }}</option>
                  <option value="UPLOAD">{{ $t('history.UPLOAD') }}</option>
                  <option value="UPLOAD_API">{{ $t('history.UPLOAD_API') }}</option>
                </select>
                <i class="fa-light fa-chevron_down cursor ml--20px z-1" size="17px" id="status-chevron-action">
                </i>
              </span>
            </div>

            <!-- Filtre user -->
            <div class="filter-item mb-3" v-if="showFilterUser()">
              <span class="filter-item-title">{{ 'Utilisateur' }}</span>
              <span class="filter-item-content">
                <input v-model="user" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': user}"
                  :placeholder="'Saisir l\'identifiant'">
              </span>
            </div>

            <!-- Filtre date de début -->
            <div class="filter-item col-4 mb-3" >
              <datetime-picker-custom format="DD/MM/YYYY H:i:s"
                :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin, 'error-datepicker': dateBeginError}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                :maxLength="19"
                :placeholderValue="$t('common.datetime_picker_empty_date')"
                inputIcon="fa-solid fa-calendar"
                v-model="dateBegin"
                :inputLabel="$t('common.date_start_label')"
                @input="delayApplyFilter(modeFilter)">
              </datetime-picker-custom>
              <span v-if="dateBeginError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
            </div>

            <!-- Filtre date de fin -->
            <div class="filter-item col-4 mb-3" >
              <datetime-picker-custom format="DD/MM/YYYY H:i:s"
                :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd, 'error-datepicker': dateEndError}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                :maxLength="19"
                :placeholderValue="$t('common.datetime_picker_empty_date')"
                inputIcon="fa-solid fa-calendar"
                v-model="dateEnd"
                :inputLabel="$t('common.date_end_label')"
                @input="delayApplyFilter(modeFilter)">
              </datetime-picker-custom>
              <span v-if="dateEndError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
            </div>

            <!-- Filtre Feature -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="showFilterFeature()">
              <span class="filter-item-title text-ellipsis">
                {{ $t('common.routing.feature') }}
              </span>
              <a :id="'feature-picker-link' + '-' + filterType + '-' + randomString" class="filter-item-content d-flex justify-content-between p-1 pt-2"
                href="#">
                <!-- <i v-if="statusDisplay.icon" :class="statusDisplay.icon"></i> -->
                <span :class="'fixed-span-size ' + (featureDisplay.nb > 0 ? 'filter-item-input-complete' : '')">{{ featureDisplay.label }}</span>
                <i class="fa-light fa-chevron-down" size="17px" id="msgType-chevron"></i>
              </a>
              <b-popover :target="'feature-picker-link' + '-' + filterType + '-' + randomString"
                :title="$t('filter.selected_feature_none')"
                triggers="focus" placement="bottom">
                <span>
                  <b-form-checkbox v-model="featureAll"
                  @change="checkAllFeature"
                    :value="true"
                    :unchecked-value="false">
                    <span>{{ featureAll ? $t('filter.all_uncheck') : $t('filter.all_check') }}</span>
                  </b-form-checkbox>
                </span>
                <hr class="my-2 mx-m08">
                <span v-for="(type, index) in featureList" :key="$t('filter.feature.feature_type.' + type.id) + '-' + index">
                  <b-form-checkbox v-model="type.state" @input="featureChange();delayApplyFilter(modeFilter)"
                    :value="1"
                    :unchecked-value="0">
                    <span>{{ $t('filter.feature.feature_type.' + type.id) }}</span>
                  </b-form-checkbox>
                </span>
              </b-popover>
            </div>

            <!-- Filtre Message Type -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="showFilterMsgType()">
              <span class="filter-item-title text-ellipsis" >
                {{ $t('common.routing.message') }}
              </span>
              <a :id="'msgType-picker-link' + '-' + filterType + '-' + randomString" class="filter-item-content d-flex justify-content-between p-1 pt-2"
                href="#">
                <!-- <i v-if="statusDisplay.icon" :class="statusDisplay.icon"></i> -->
                <span :class="'fixed-span-size ' + (messageTypeDisplay.nb > 0 ? 'filter-item-input-complete' : '')">{{ messageTypeDisplay.label }}</span>
                <i class="fa-light fa-chevron-down" size="17px" id="msgType-chevron"></i>
              </a>
              <b-popover :target="'msgType-picker-link' + '-' + filterType + '-' + randomString"
                :title="$t('filter.selected_msg_type_none')"
                triggers="focus" placement="bottom">
                <span>
                  <b-form-checkbox v-model="msgTypeAll"
                  @change="checkAllMsgType"
                    :value="true"
                    :unchecked-value="false">
                    <span>{{ msgTypeAll ? $t('filter.all_uncheck') : $t('filter.all_check') }}</span>
                  </b-form-checkbox>
                </span>
                <hr class="my-2 mx-m08">
                <span v-for="(type, index) in msgTypeList" :key="$t('filter.orphan.message_type.' + type.id) + '-' + index">
                  <b-form-checkbox v-model="type.state" @input="msgTypeChange();delayApplyFilter(modeFilter)"
                    :value="1"
                    :unchecked-value="0">
                    <span>{{ $t('filter.orphan.message_type.' + type.id) }}</span>
                  </b-form-checkbox>
                </span>
              </b-popover>
            </div>

            <!-- Filtre Init Party -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="showFilterInitParty()">
              <span class="filter-item-title text-ellipsis">{{ $t('orphan.init_party') }}</span>
              <span class="filter-item-content">
                <input v-model="initParty" @input="delayApplyFilter(modeFilter)"
                  type="text"
                  autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': initParty}"
                  :placeholder="$t('orphan.init_party')"
                  :aria-label="$t('orphan.init_party')">
              </span>
            </div>

            <!-- Filtre Message ID (OrphanFlux) -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="showFilterMsgIdOrphan()">
              <span class="filter-item-title text-ellipsis">{{ $t('orphan.msg_identifier') }}</span>
              <span class="filter-item-content">
                <input v-model="msgId" @input="delayApplyFilter(modeFilter)"
                  type="text"
                  autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': msgId}"
                  :placeholder="$t('orphan.msg_identifier')"
                  :aria-label="$t('orphan.msg_identifier')">
              </span>
            </div>

            <!-- ADVANCED FILTERS -->

            <!-- Filtre debtor provider id -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterDebtorIdProvider()">
              <span class="filter-item-title text-ellipsis">{{ $t('requestToPay.debtor_agent_id') }}</span>
              <span class="filter-item-content">
                <input v-model="debtorIdProvider" @input="delayApplyFilter(modeFilter)"
                  type="text"
                  autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': debtorIdProvider}"
                  :placeholder="$t('requestToPay.debtor_agent_id')"
                  :aria-label="$t('requestToPay.debtor_agent_id')">
              </span>
            </div>

            <!-- Filtre debtor provider name -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterDebtorNameProvider()">
              <span class="filter-item-title text-ellipsis">{{ $t('requestToPay.debtor_agent_name') }}</span>
              <span class="filter-item-content">
                <input v-model="debtorNameProvider" @input="delayApplyFilter(modeFilter)"
                  type="text"
                  autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': debtorNameProvider}"
                  :placeholder="$t('requestToPay.debtor_agent_name')"
                  :aria-label="$t('requestToPay.debtor_agent_name')">
              </span>
            </div>

            <!-- Filtre ultimate debtor BEI -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterUltimateDebtorBEI()">
              <span class="filter-item-title text-ellipsis">{{ $t('requestToPay.debtor_ultimate_bei') }}</span>
              <span class="filter-item-content">
                <input v-model="ultimateDebtorBEI" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': ultimateDebtorBEI}"
                  :placeholder="$t('requestToPay.debtor_ultimate_bei')"
                  :aria-label="$t('requestToPay.debtor_ultimate_bei')">
              </span>
            </div>

            <!-- Filtre creditor account -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterCreditorAccount()">
              <span class="filter-item-title text-ellipsis">{{ $t('requestToPay.creditor_account') }}</span>
              <span class="filter-item-content">
                <input v-model="creditorAccount" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': creditorAccount}"
                  :placeholder="$t('requestToPay.creditor_account')"
                  :aria-label="$t('requestToPay.creditor_account')">
              </span>
            </div>

            <!-- Filtre creditor name -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterCreditorName()">
              <span class="filter-item-title text-ellipsis">{{ $t('requestToPay.creditor_name') }}</span>
              <span class="filter-item-content">
                <input v-model="creditorName" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': creditorName}"
                  :placeholder="$t('requestToPay.creditor_name')"
                  :aria-label="$t('requestToPay.creditor_name')">
              </span>
            </div>
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterCreditorName()">
            </div>

            <!-- Filtre creditor provider id -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterCreditorIdProvider()">
              <span class="filter-item-title text-ellipsis">{{ $t('requestToPay.creditor_agent_id') }}</span>
              <span class="filter-item-content">
                <input v-model="creditorIdProvider" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': creditorIdProvider}"
                  :placeholder="$t('requestToPay.creditor_agent_id')"
                  :aria-label="$t('requestToPay.creditor_agent_id')">
              </span>
            </div>

            <!-- Filtre creditor provider name -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterCreditorNameProvider()">
              <span class="filter-item-title text-ellipsis">{{ $t('requestToPay.creditor_agent_name') }}</span>
              <span class="filter-item-content">
                <input v-model="creditorNameProvider" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': creditorNameProvider}"
                  :placeholder="$t('requestToPay.creditor_agent_name')"
                  :aria-label="$t('requestToPay.creditor_agent_name')">
              </span>
            </div>

            <!-- Filtre ultimate creditor BEI -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterUltimateCreditorBEI()">
              <span class="filter-item-title text-ellipsis">{{ $t('requestToPay.creditor_ultimate_bei') }}</span>
              <span class="filter-item-content">
                <input v-model="ultimateCreditorBEI" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': ultimateCreditorBEI}"
                  :placeholder="$t('requestToPay.creditor_ultimate_bei')"
                  :aria-label="$t('requestToPay.creditor_ultimate_bei')">
              </span>
            </div>

            <!-- Filtre endToEndId -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterEndToEndId()">
              <span class="filter-item-title text-ellipsis">{{ $t('filter.end_to_end_id') }}</span>
              <span class="filter-item-content">
                <input v-model="endToEndId" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': endToEndId}"
                  :placeholder="$t('filter.end_to_end_id')"
                  :aria-label="$t('filter.end_to_end_id')">
              </span>
            </div>
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterEndToEndId()">
            </div>
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterEndToEndId()">
            </div>

            <!-- Filtre creationDateBegin -->
            <div class="filter-item col-4 mb-3" v-if="hasAdvancedFilters && showFilterCreationDateBegin()">
              <datetime-picker-custom format="DD/MM/YYYY H:i:s"
                :class="{'filter-item-input': true, 'filter-item-input-complete': creationDateBegin, 'error-datepicker': creationDateBeginError}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                :maxLength="19"
                :placeholderValue="$t('common.datetime_picker_empty_date')"
                inputIcon="fa-solid fa-calendar"
                v-model="creationDateBegin"
                :inputLabel="$t('filter.creation_date_begin')"
                @input="delayApplyFilter(modeFilter)">
              </datetime-picker-custom>
              <span v-if="creationDateBeginError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
            </div>

            <!-- Filtre creationDateEnd -->
            <div class="filter-item col-4 mb-3" v-if="hasAdvancedFilters && showFilterCreationDateEnd()">
              <datetime-picker-custom format="DD/MM/YYYY H:i:s"
                :class="{'filter-item-input': true, 'filter-item-input-complete': creationDateEnd, 'error-datepicker': creationDateEndError}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                :maxLength="19"
                :placeholderValue="$t('common.datetime_picker_empty_date')"
                inputIcon="fa-solid fa-calendar"
                v-model="creationDateEnd"
                :inputLabel="$t('filter.creation_date_end')"
                @input="delayApplyFilter(modeFilter)">
              </datetime-picker-custom>
              <span v-if="creationDateEndError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
            </div>
            <div class="filter-item col-4 mt-3 text-truncate" v-if="hasAdvancedFilters && showFilterUltimateCreditorBEI()">
            </div>

            <!-- Filtre requestedPaymentDateBegin -->
            <div class="filter-item col-4 mb-3" v-if="hasAdvancedFilters && showFilterRequestedPaymentDateBegin()">
              <datetime-picker-custom format="DD/MM/YYYY H:i:s"
                :class="{'filter-item-input': true, 'filter-item-input-complete': requestedPaymentDateBegin, 'error-datepicker': requestedPaymentDateBeginError}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                :maxLength="19"
                :placeholderValue="$t('common.datetime_picker_empty_date')"
                inputIcon="fa-solid fa-calendar"
                v-model="requestedPaymentDateBegin"
                :inputLabel="$t('common.exec_date_start')"
                @input="delayApplyFilter(modeFilter)">
              </datetime-picker-custom>
              <span v-if="requestedPaymentDateBeginError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
            </div>

            <!-- Filtre requestedPaymentDateEnd -->
            <div class="filter-item col-4 mb-3" v-if="hasAdvancedFilters && showFilterRequestedPaymentDateEnd()">
              <datetime-picker-custom format="DD/MM/YYYY H:i:s"
                :class="{'filter-item-input': true, 'filter-item-input-complete': requestedPaymentDateEnd, 'error-datepicker': requestedPaymentDateEndError}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                :maxLength="19"
                :placeholderValue="$t('common.datetime_picker_empty_date')"
                inputIcon="fa-solid fa-calendar"
                v-model="requestedPaymentDateEnd"
                :inputLabel="$t('common.exec_date_end')"
                @input="delayApplyFilter(modeFilter)">
              </datetime-picker-custom>
              <span v-if="requestedPaymentDateEndError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
            </div>
            <div class="filter-item col-4 mt-3 text-truncate" v-if="hasAdvancedFilters && showFilterUltimateCreditorBEI()">
            </div>

            <!-- Filtre expirationDateBegin -->
            <div class="filter-item col-4 mb-3" v-if="hasAdvancedFilters && showFilterExpirationDateBegin()">
              <datetime-picker-custom format="DD/MM/YYYY H:i:s"
                :class="{'filter-item-input': true, 'filter-item-input-complete': expirationDateBegin, 'error-datepicker': expirationDateBeginError}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                :maxLength="19"
                :placeholderValue="$t('common.datetime_picker_empty_date')"
                inputIcon="fa-solid fa-calendar"
                v-model="expirationDateBegin"
                :inputLabel="$t('common.expiration_date_start')"
                @input="delayApplyFilter(modeFilter)">
              </datetime-picker-custom>
              <span v-if="expirationDateBeginError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
            </div>

            <!-- Filtre expirationDateEnd -->
            <div class="filter-item col-4 mb-3" v-if="hasAdvancedFilters && showFilterExpirationDateEnd()">
              <datetime-picker-custom format="DD/MM/YYYY H:i:s"
                :class="{'filter-item-input': true, 'filter-item-input-complete': expirationDateEnd, 'error-datepicker': expirationDateEndError}"
                customInputParentClass="filter-item-content"
                customInputClass="w-100"
                :maxLength="19"
                :placeholderValue="$t('common.datetime_picker_empty_date')"
                inputIcon="fa-solid fa-calendar"
                v-model="expirationDateEnd"
                :inputLabel="$t('common.expiration_date_end')"
                @input="delayApplyFilter(modeFilter)">
              </datetime-picker-custom>
              <span v-if="expirationDateEndError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
            </div>
            <div class="filter-item col-4 mt-3 text-truncate" v-if="hasAdvancedFilters && showFilterUltimateCreditorBEI()">
            </div>

            <!-- Filtre reason is modifiable -->
            <div class="filter-item col-4 mb-3" v-if="hasAdvancedFilters && showFilterReasonEditable()">
              <span id="reason-editable-label" class="filter-item-title">{{ $t('common.rsn_editable') }}</span>
              <span class="filter-item-content d-flex">
                <select autocomplete="off" id="sel2"
                aria-labelledby="reason-editable-label"
                v-model="reasonEditable"
                class="cursor fs-in h-auto z-2 blue-green-bg">
                  <option value="">{{ $t('common.all') }}</option>
                  <option value="1">{{ $t('common.yes_label') }}</option>
                  <option value="0">{{ $t('common.no_label') }}</option>
                </select>
                <i class="fa-light fa-chevron-down cursor ml-20px mt-1 z-1" size="17px" id="status-chevron-reason">
                </i>
              </span>
            </div>

            <!-- Filtre raison -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterReason()">
              <span class="filter-item-title text-ellipsis" >{{ $t('filter.reason') }}</span>
              <span class="filter-item-content">
                <input v-model="reason" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': reason}"
                  :placeholder="$t('filter.reason')"
                  :aria-label="$t('filter.reason'+ ' (' + $t('common.filter') + ')')">
              </span>
            </div>

            <!-- Filtre modified reason -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterModifiedReason()">
              <span class="filter-item-title text-ellipsis">{{ $t('common.rsn_new') }}</span>
              <span class="filter-item-content">
                <input v-model="modifiedReason" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': modifiedReason}"
                  :placeholder="$t('common.rsn_new')"
                  :aria-label="$t('common.rsn_new')">
              </span>
            </div>

            <!-- Filtre amount -->
            <div
                v-if="hasAdvancedFilters && showFilterAmount()"
                class="filter-item col-4 mb-3 text-truncate">

              <label for="request-to-pay-amount" class="filter-item-title text-ellipsis">
                <span aria-hidden="true"></span>
                <span class="sr-only">
                  {{ $t('requestToPay.amount_filter_accessible') }}
                </span>
              </label>

              <span class="filter-item-content">
                <input
                    id="request-to-pay-amount"
                    v-model="amount"
                    type="text"
                    :placeholder="$t('requestToPay.amnt')"
                    autocomplete="off"
                    :class="{
                    'filter-item-input': true,
                    'filter-item-input-complete': amount
                  }"
                    @input="delayApplyFilter(modeFilter)">
              </span>
            </div>

            <!-- Filtre currency -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterCurrency()">
              <span class="filter-item-title text-ellipsis">{{ $t('common.crcy') }}</span>
              <span class="filter-item-content">
                <input v-model="currency" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': currency}"
                  :placeholder="$t('common.crcy')"
                  :aria-label="$t('common.crcy')">
              </span>
            </div>
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterCurrency()">
            </div>

            <!-- Filtre amount is modifiable -->
            <div class="filter-item col-4 mb-3" v-if="hasAdvancedFilters && showFilterAmountEditable()">
              <span id="amount-editable-label" class="filter-item-title">{{ $t('requestToPay.amnt_editable') }}</span>
              <span class="filter-item-content d-flex">
                <select autocomplete="off" id="sel3"
                v-model="amountEditable"
                aria-labelledby="amount-editable-label"
                class="cursor fs-in h-auto z-2 blue-green-bg">
                  <option value="">{{ $t('common.all') }}</option>
                  <option value="1">{{ $t('common.yes_label') }}</option>
                  <option value="0">{{ $t('common.no_label') }}</option>
                </select>
                <i class="fa-light fa-chevron-down cursor ml-20px mt-1 z-1" size="17px" id="status-chevron-amount">
                </i>
              </span>
            </div>

            <!-- Filtre original amount -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterAmountOrig()">
              <span class="filter-item-title text-ellipsis" >{{ $t('requestToPay.amnt_orig') }}</span>
              <span class="filter-item-content">
                <input v-model="amountOrig" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': amountOrig}"
                  :placeholder="$t('requestToPay.amnt_orig')"
                  :aria-label="$t('requestToPay.amnt_orig')">
              </span>
            </div>

            <!-- Filtre modified amount -->
            <div class="filter-item col-4 mb-3 text-truncate" v-if="hasAdvancedFilters && showFilterAmountModif()">
              <span class="filter-item-title text-ellipsis">{{ $t('requestToPay.amnt_modified') }}</span>
              <span class="filter-item-content">
                <input v-model="amountModif" @input="delayApplyFilter(modeFilter)"
                  type="text"
                       autocomplete="off"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': amountModif}"
                  :placeholder="$t('requestToPay.amnt_modified')"
                  :aria-label="$t('requestToPay.amnt_modified')">
              </span>
            </div>

          </b-col>

          <b-col cols="3">
            <!-- Bouton Effacer et Appliquer -->
            <b-col class="d-flex flex-row-reverse" :class="modeFilter === 3 ? 'mt-5' : 'mt-4'">
              <b-button size="sm"
                @click="applyFilter(modeFilter)">
                {{ $t('filter.fltr') }}
              </b-button>
              <b-button class="mr-2 d-inline d-xl-none" size="sm"
                @click="clearFilterFields"
                :disabled="!hasInputFilter">
                {{ $t('creation_forms.clear_label') }}
              </b-button>
              <b-button class="mr-2 d-none d-xl-inline" size="sm"
                @click="clearFilterFields"
                :disabled="!hasInputFilter">
                {{ $t('filter.clr_fltr_field') }}
              </b-button>
            </b-col>
            <b-col class="d-flex flex-row-reverse" :class="modeFilter === 3 ? 'mt-5' : 'mt-4 pt-2'" v-if="modeFilter === 1">
              <b-button class="d-inline"
                @click="hasAdvancedFilters^=1">
                {{ hasAdvancedFilters ? $t('filter.fltr_less') : $t('filter.fltr_more') }}
              </b-button>
            </b-col>
          </b-col>
        </b-row>
      </f7-list-item>
    </f7-list>
  </div>

</template>

<script>
// import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
// import statusListJson from '@/components/common/Filter/statusList.json'

import { formatDateTime } from '@/helpers/format'
import { statusLabel, statusIcon } from '@/helpers/labels.js'
import services from '@/helpers/services.js'
import Status from '@/helpers/status.js'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'MessagesFilter',
  components: {
    'datetime-picker-custom': dateTimePicker,
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    aloneTab: {
      type: Boolean,
      default: true
    },
    buttonCreateSupplier: {
      type: Boolean,
      default: false
    },
    buttonCreateVerify: {
      type: Boolean,
      default: false
    },
    filterType: {
      type: String,
      default: 'list'
    },
    isHistory: {
      type: Boolean,
      default: false
    },
    isBackOffice: {
      type: Boolean,
      default: false
    },
    isCompany: {
      type: Boolean,
      default: false
    },
    isRTPListBack: {
      type: Boolean,
      default: false
    },
    isPayments: {
      type: Boolean,
      default: true
    },
    isVerifications: {
      type: Boolean,
      default: false
    },
    listMainTitle: {
      type: String,
      default: ''
    },
    loadFilters: {
      default: '0',
      type: String
    },
    mode: {
      type: Number,
      default: 1
    },
    propedServiceId: {
      type: String,
      default: 'none'
    },
    randomId: {
      type: String,
      default: ''
    },
    received: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      debtorFilterId: `ibanDebtorFilter-${this._uid}`,
      amount: '',
      amountEditable: '',
      amountOrig: '',
      amountModif: '',
      hasAdvancedFilters: false,
      arrayStatusList: {
        Standard: ['1', '5', '9', '10', '11'],
        Rejection: ['6', '7', '12'],
        Recall: ['13', '14', '15'],
        Payment: ['19', '20', '21', '22', '23', '24', '25']
      },
      creationDateBegin: '',
      creationDateBeginError: false,
      creationDateEnd: '',
      creationDateEndError: false,
      currency: '',
      dir: 0,
      displayFilter: true,
      hasDefaultFilter: false,
      dateBegin: '',
      dateBeginError: false,
      dateEnd: '',
      dateEndError: false,
      debtorId: '',
      debtorIdProvider: '',
      debtorName: '',
      debtorNameProvider: '',
      creditorIdProvider: '',
      creditorAccount: '',
      creditorName: '',
      creditorNameProvider: '',
      cdtrOrDbtrNm: '',
      endToEndId: '',
      expirationDateBegin: '',
      expirationDateBeginError: false,
      expirationDateEnd: '',
      expirationDateEndError: false,
      featureAll: true,
      initParty: '',
      modifiedReason: '',
      msgId: '',
      msgTypeAll: true,
      msgTypeList: {
        Report: {
          label: this.$t('filter.report'),
          id: '1',
          icon: '',
          state: 1
        },
        CancellationReport: {
          label: this.$t('filter.cnclltn_report'),
          id: '2',
          icon: '',
          state: 1
        },
        CancellationRequest: {
          label: this.$t('filter.cnclltn_request'),
          id: '3',
          icon: '',
          state: 1
        },
        PaymentReport: {
          label: this.$t('filter.cnclltn_report'),
          id: '5',
          icon: '',
          state: 1
        },
        RequestStatusUpdate: {
          label: this.$t('filter.request_status_update'),
          id: '6',
          icon: '',
          state: 1
        },
        CancellationRequestStatusUpdate: {
          label: this.$t('filter.cancellation_request_status_update'),
          id: '7',
          icon: '',
          state: 1
        }
      },
      normId: '',
      normList: [
        {
          id: 1,
          label: this.$i18n.t('common.norm.srtp'),
        },
        {
          id: 2,
          label: this.$i18n.t('common.norm.giro'),
        },
        {
          id: 3,
          label: this.$i18n.t('common.norm.psd2'),
        }
      ],
      featureListFull: {
        // RTPI001: {
        //   label: this.$t('filter.feature.feature_type.1'),
        //   id: '1',
        //   icon: '',
        //   state: 1
        // },
        RTPI002: {
          label: this.$t('filter.feature.feature_type.2'),
          id: '2',
          icon: '',
          state: 1
        },
        RTPI003: {
          label: this.$t('filter.feature.feature_type.3'),
          id: '3',
          icon: '',
          state: 1
        },
        RTPI004: {
          label: this.$t('filter.feature.feature_type.4'),
          id: '4',
          icon: '',
          state: 1
        },
        RTPI005: {
          label: this.$t('filter.feature.feature_type.45'),
          id: '5',
          icon: '',
          state: 1
        },
        RTPI006: {
          label: this.$t('filter.feature.feature_type.6'),
          id: '6',
          icon: '',
          state: 1
        },
        // RTPI007: {
        //   label: this.$t('filter.feature.feature_type.7'),
        //   id: '7',
        //   icon: '',
        //   state: 1
        // },
        RTPI008: {
          label: this.$t('filter.feature.feature_type.8'),
          id: '8',
          icon: '',
          state: 1
        },
        RTPI009: {
          label: this.$t('filter.feature.feature_type.9'),
          id: '9',
          icon: '',
          state: 1
        },
        RTPI010: {
          label: this.$t('filter.feature.feature_type.10'),
          id: '10',
          icon: '',
          state: 1
        },
        RTPI011: {
          label: this.$t('filter.feature.feature_type.11'),
          id: '11',
          icon: '',
          state: 1
        },
      },
      featureList: {},
      role: 2,
      section: 1,
      typeAction: '',
      user: '',
      status: '',
      filterDocumentType: '',
      filterSiren: '',
      filterSupplierName: '',
      filterSupplierId: '',
      filterTypeGet: 'list',
      LMSGsupplierconfig: this.$engine.services.suppliers.LMSGsupplierconfig,
      modeFilter: this.mode,
      originalReason: '',
      reason: '',
      reasonEditable: '',
      requestedPaymentDateBegin: '',
      requestedPaymentDateBeginError: false,
      requestedPaymentDateEnd: '',
      requestedPaymentDateEndError: false,
      services: services,
      statusKYC: [
        {
          code: 0,
          label: this.$t('suppliers.waiting')
        },
        {
          code: 31,
          label: this.$t('suppliers.validated')
        },
        {
          code: 20,
          label: this.$t('common.status.provider_to_refresh')
        }
      ],
      statusVerif: [
        {
          code: 1,
          label: this.$t('acceptance.ok')
        },
        {
          code: 3,
          label: this.$t('acceptance.warn')
        },
        {
          code: 4,
          label: this.$t('acceptance.ko')
        }
      ],
      statusList: {
        statusIssued: {
          label: statusLabel(this.$i18n, Status.RTP_ISSUED),
          id: '1',
          icon: '',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusWaiting: {
          label: statusLabel(this.$i18n, Status.RTP_WAITING),
          id: '1',
          icon: statusIcon(Status.WAITING),
          state: 0,
          filterName: 'list',
          services: ['2', '6']
        },
        statusExpired: {
          label: statusLabel(this.$i18n, Status.RTP_EXPIRED),
          id: '12',
          icon: statusIcon(Status.EXPIRED),
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusExpiring: {
          id: '120',
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusCanceled: {
          id: '14',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusBeingCanceled: {
          id: '13',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusCancellationRejected: {
          id: '15',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusRequestReceived: {
          label: statusLabel(this.$i18n, Status.RTP_RECEIVED),
          id: '5',
          icon: statusIcon(Status.RECEIVED),
          state: 1,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestAccepted: {
          label: statusLabel(this.$i18n, Status.RTP_ACCEPTED),
          id: '10',
          icon: statusIcon(Status.ACCEPTED),
          state: 1,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestRevoked: {
          label: statusLabel(this.$i18n, Status.RTP_REVOKED),
          id: '11',
          icon: statusIcon(Status.REVOKED),
          state: 1,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestModified: {
          label: statusLabel(this.$i18n, Status.RTP_MODIFIED),
          id: '9',
          icon: statusIcon(Status.MODIFIED),
          state: 1,
          filterName: 'list',
          services: ['1']
        },
         statusInstallmentPaid: {
           label: statusLabel(this.$i18n, Status.RTP_INSTALLMENT_PAID),
           id:'30',
           icon: statusIcon(Status.INSTALLMENT_PAID),
           state: 0,
           filterName: 'list',
           services: ['1']
         },
         statusMessageFormatIncorrect: {
           label: statusLabel(this.$i18n, Status.RTP_MSG_FORMAT_INCORRECT),
           id: '7',
           icon: statusIcon(Status.REJECTED),
           state: 1,
           filterName: 'list',
           services: ['1']
         },
        statusRejected: {
          label: statusLabel(this.$i18n, Status.REJECTED),
          id: '6',
          icon: statusIcon(Status.REJECTED),
          state: 1,
          filterName: 'list',
          services: ['1', '2']
        },
        statusPaymentWaitingInitiation: {
          id: '19',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentInitiated: {
          id: '20',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentRejected: {
          id: '21',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentSettled: {
          id: '22',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentPartiallySettled: {
          id: '23',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentValidated: {
          id: '24',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentRefused: {
          id: '25',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
      },
      randomString: '',
      serviceId: '',
      timer: '',
      ultimateCreditorBEI: '',
      ultimateDebtorBEI: ''
    }
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    hasInbound () {
      return ['1', '2'].includes(this.$engine.user.getUserNorm())
    },
    hasOutbound () {
      return ['1', '3'].includes(this.$engine.user.getUserNorm())
    },
    realMessageTypeList () {
      let that = this
      const list = []
      for (const property in that.msgTypeList) {
        const type = that.msgTypeList[property]
        list.push({
          tag: property,
          label: type.label,
          icon: type.icon,
          state: type.state,
          id: type.id
        })
      }
      return list
    },
    messageTypeDisplay () {
      let realMessageTypeList = this.realMessageTypeList.filter(type => type.state === 1)
      if (realMessageTypeList.length === 0) {
        return {
          label: this.$t('filter.selected_msg_type_none'),
          nb: 0
        }
      } else if (realMessageTypeList.length === 1) {
        return {
          label: this.serviceId === '1' ? this.$t('filter.orphan.message_type.' + realMessageTypeList[0].id) : realMessageTypeList[0].label,
          icon: realMessageTypeList[0].icon,
          nb: 1
        }
      } else {
        return {
          label: this.$t('filter.selected_msg_type_many', {nbMsgType: realMessageTypeList.length}),
          nb: realMessageTypeList.length
        }
      }
    },
    realNormList () {
      let that = this
      const list = []
      for (const property in that.normList) {
        const norm = that.normList[property]
        list.push({
          tag: property,
          label: norm.label,
          state: norm.state,
          id: norm.id
        })
      }
      return list
    },
    realFeatureList () {
      let that = this
      const list = []
      for (const property in that.featureList) {
        const type = that.featureList[property]
        if (type) {
          list.push({
            tag: property,
            label: type.label,
            icon: type.icon,
            state: type.state,
            id: type.id
          })
        }
      }
      return list
    },
    featureDisplay () {
      let realFeatureList = this.realFeatureList.filter(type => type.state === 1)
      if (realFeatureList.length === 0) {
        return {
          label: this.$t('filter.selected_feature_none'),
          nb: 0
        }
      } else if (realFeatureList.length === 1) {
        return {
          label: this.serviceId === '1' ? this.$t('filter.feature.feature_type.' + realFeatureList[0].id) : realFeatureList[0].label,
          icon: realFeatureList[0].icon,
          nb: 1
        }
      } else {
        return {
          label: this.$t('filter.selected_feature_many', {nbFeature: realFeatureList.length}),
          nb: realFeatureList.length
        }
      }
    },
    realStatusList () {
      let that = this
      const list = []
      for (const property in that.statusList) {
        const status = that.statusList[property]
        list.push({
          tag: property,
          label: status.label,
          icon: status.icon,
          state: status.state,
          id: status.id
        })
      }
      return list
    },
    normDisplay () {
      let realNormList = this.realNormList.filter(norm => norm.state === 1)
      if (realNormList.length === 0) {
        return {
          label: this.$t('filter.selected_standard_none'),
          nb: 0
        }
      } else if (realNormList.length === 1) {
        return {
          label: realNormList[0].label,
          icon: realNormList[0].icon,
          nb: 1
        }
      } else {
        return {
          label: this.$t('filter.selected_standard_many', {nbNorm: realNormList.length}),
          nb: realNormList.length
        }
      }
    },
    statusDisplay () {
      let realStatusList = this.realStatusList.filter(status => status.state === 1)
      if (realStatusList.length === 0) {
        return {
          label: this.$t('filter.selected_status_none'),
          nb: 0
        }
      } else if (realStatusList.length === 1) {
        return {
          label: this.serviceId === '1' ? this.$t('common.status.rtp.' + realStatusList[0].id) : realStatusList[0].label,
          icon: realStatusList[0].icon,
          nb: 1
        }
      } else {
        return {
          label: this.$t('filter.selected_status_many', {nbStatus: realStatusList.length}),
          nb: realStatusList.length
        }
      }
    },
    hasInputFilter () {
      if ((!this.allStatus() && this.modeFilter !== 2) ||
        ((this.mode !== 5 && this.dateBegin) || (this.mode === 5 && this.dateBegin !== moment().format('01/MM/YYYY 00:00:00'))) ||
        this.creationDateBegin ||
        this.creationDateEnd ||
        this.requestedPaymentDateBegin ||
        this.requestedPaymentDateEnd ||
        this.expirationDateBegin ||
        this.expirationDateEnd ||
        this.dateEnd ||
        this.initParty ||
        this.status === 0 ||
        this.status ||
        !this.featureAll ||
        !this.msgTypeAll ||
        this.normId ||
        this.cdtrOrDbtrNm ||
        this.debtorId ||
        this.endToEndId ||
        this.reason ||
        this.originalReason ||
        this.modifiedReason ||
        this.reasonEditable ||
        this.typeAction ||
        this.user ||
        this.filterDocumentType ||
        this.filterSiren ||
        this.filterSupplierName ||
        this.filterSupplierId ||
        this.debtorIdProvider ||
        this.debtorName ||
        this.debtorNameProvider ||
        this.ultimateDebtorBEI ||
        this.creditorIdProvider ||
        this.creditorAccount ||
        this.creditorName ||
        this.creditorNameProvider ||
        this.ultimateCreditorBEI ||
        this.amount ||
        this.amountEditable ||
        this.amountOrig ||
        this.amountModif ||
        this.currency ||
        this.msgId ) {
        return true
      }
      return false
    },
    listTitle () {
      let fromServiceIdToLabel = {
        0: {
          '6': this.$t('Webheader.my_drafts')
        },
        1: {
          '1': this.$t('Webheader.my_claims_list'),
          '2': this.$t('Webheader.my_modular_loans'),
          '6': this.$t('Webheader.my_transfers'),
          '7': this.$t('Webheader.my_business_folders'),
          '8': this.$t('Webheader.my_suppliers')
        },
        2: {
          '1': this.$t('Webheader.my_claims_folders'),
          '7': this.$t('Webheader.my_business_documents_to_validate')
        }
      }
      if (this.isHistory) {
        return this.$t('Webheader.history')
      } else if (this.isCompany) {
        return this.$t('Webheader.company')
      } else if (this.isVerifications) {
        return this.$t('Webheader.my_verifications')
      }
      if (this.listMainTitle === '') {
        return fromServiceIdToLabel[this.modeFilter][this.$engine.user.currentService.id]
      }
      return this.listMainTitle
    },
    filterFields () {
      let that = this
      let filter = {}

      // Date, Reason and Name values
      filter.dateBegin = this.dateBegin
      filter.dateEnd = this.dateEnd
      filter.creationDateBegin = this.creationDateBegin
      filter.creationDateEnd = this.creationDateEnd
      filter.requestedPaymentDateBegin = this.requestedPaymentDateBegin
      filter.requestedPaymentDateEnd = this.requestedPaymentDateEnd
      filter.expirationDateBegin = this.expirationDateBegin
      filter.expirationDateEnd = this.expirationDateEnd
      filter.initParty = this.initParty
      filter.status = this.status
      filter.SocialReason = this.filterSupplierName
      filter.cdtrOrDbtrNm = this.cdtrOrDbtrNm
      filter.debtorId = this.debtorId
      filter.endToEndId = this.endToEndId
      filter.reason = this.reason
      filter.originalReason = this.originalReason
      filter.modifiedReason = this.modifiedReason
      filter.reasonEditable = this.reasonEditable
      filter.typeAction = this.typeAction
      filter.user = this.user
      filter.filterDocumentType = this.filterDocumentType
      filter.filterSiren = this.filterSiren
      filter.filterSupplierName = this.filterSupplierName
      filter.filterSupplierId = this.filterSupplierId
      filter.hasDefaultFilter = this.hasDefaultFilter
      filter.debtorIdProvider = this.debtorIdProvider
      filter.debtorName = this.debtorName
      filter.debtorNameProvider = this.debtorNameProvider
      filter.ultimateDebtorBEI = this.ultimateDebtorBEI
      filter.msgId = this.msgId
      filter.creditorIdProvider = this.creditorIdProvider
      filter.creditorAccount = this.creditorAccount
      filter.creditorName = this.creditorName
      filter.creditorNameProvider = this.creditorNameProvider
      filter.ultimateCreditorBEI = this.ultimateCreditorBEI
      filter.amount = this.amount
      filter.amountEditable = this.amountEditable
      filter.amountOrig = this.amountOrig
      filter.amountModif = this.amountModif
      filter.currency = this.currency

      // Status values
      for (let property in this.statusList) {
        let status = that.statusList[property]
        filter[property] = status.state
      }

      // Message type values
      for (let property in this.msgTypeList) {
        let type = that.msgTypeList[property]
        filter[property] = type.state
      }

      // Feature type values
      for (let property in this.featureList) {
        let type = that.featureList[property]
        if (type) {
          filter[property] = type.state
        }
      }

      return filter
    }
  },
  watch: {
    amountEditable () {
      // this.delayApplyFilter(this.modeFilter)
      this.communicateChange()
    },
    hasDefaultFilter () {
      this.communicateChange()
    },
    dateBegin () {
      this.communicateChange()
    },
    dateEnd () {
      this.communicateChange()
    },
    creationDateBegin () {
      this.communicateChange()
    },
    creationDateEnd () {
      this.communicateChange()
    },
    requestedPaymentDateBegin () {
      this.communicateChange()
    },
    requestedPaymentDateEnd () {
      this.communicateChange()
    },
    expirationDateBegin () {
      this.communicateChange()
    },
    expirationDateEnd () {
      this.communicateChange()
    },
    Status () {
      this.communicateChange()
    },
    cdtrOrDbtrNm () {
      this.communicateChange()
    },
    endToEndId () {
      this.communicateChange()
    },
    reason () {
      this.communicateChange()
    },
    originalReason () {
      this.communicateChange()
    },
    modifiedReason () {
      this.communicateChange()
    },
    reasonEditable () {
      // this.delayApplyFilter(this.modeFilter)
      this.communicateChange()
    },
    typeAction () {
      this.communicateChange()
    },
    user () {
      this.communicateChange()
    },
    filterDocumentType () {
      this.communicateChange()
    },
    filterSiren () {
      this.communicateChange()
    },
    filterSupplierName () {
      this.communicateChange()
    },
    filterSupplierId () {
      this.communicateChange()
    },
    role () {
      this.applyFilter(this.modeFilter)
    },
    normList: {
      deep: true,
      handler () {
        this.communicateChange()
      }
    },
    msgTypeList: {
      deep: true,
      handler () {
        this.communicateChange()
      }
    }
  },
  created () {
    if (this.mode === 5) {
      // change default section and feature filters
      if (this.$engine.user.getUserNorm() === '3') {
        this.section = 2
      }
      this.changeFeatureFilters()
    }
    // this.statusList = statusListJson.statusList
    if (this.propedServiceId === 'none') {
      this.serviceId = this.$engine.user.currentService.id
    } else {
      this.serviceId = this.propedServiceId
    }
    this.filterTypeGet = this.filterType

    if (this.loadFilters === '1') {
      this.loadSavedFiltersInFields()
    }

    this.$bus.on('service:change', (val) => {
      this.serviceId = this.$engine.services.getServiceIdByName(val)
    })
    this.$bus.emit('right-panel-set-feature', 'filter-messages')

    // Command "apply filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-apply-filter-' + this.randomId, (filter = {}) => {
      if (Object.keys(filter).length) {
        this.applyFilter(1, filter)
      } else {
        this.applyFilter()
      }
    })
    // Command "set value" from page
    this.$bus.on('filter-set-value', (obj) => {
      this[obj.name] = obj.value
    })
    // Command "clear filter fields" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-clear-filter-fields', () => {
      this.clearFilterFields()
    })
    // Command "save filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-save-filter', () => {
      this.saveDefaultFilter()
    })
    // Command "delete filter" from the right-panel-filter-view (mobile)
    this.$bus.on('filter-delete-filter', () => {
      this.deleteFilter()
    })

    // Intercepts filter changes from the right-panel-filter-view (mobile)
    this.$bus.on('filter-update-fields', (filter) => {
      for (const property in filter) {
        if (this.statusList[property] !== undefined) {
          // Set filter status values
          this.statusList[property].state = filter[property]
        } else {
          // Set filter other values
          this[property] = filter[property]
        }
      }
    })
  },
  mounted () {
    this.dir = this.$settings.msgDirection
    this.randomString = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)

    let actualService = this.getActualService()
    var defaultFilter = {}
    switch (this.filterTypeGet) {
      case 'details':
        defaultFilter = actualService.filterDetails.getDefaultFilter()
        if (this.modeFilter === 2) {
          defaultFilter.statusDocRejected = 1
          defaultFilter.statusDocValidated = 1
        }
        break
      case 'draft':
        defaultFilter = actualService.filterDraft.getDefaultFilter()
        break
      case 'group':
        defaultFilter = actualService.filterGroup.getDefaultFilter()
        break
      case 'list':
        defaultFilter = actualService.filter.getDefaultFilter()
        break
      default:
        break
    }

    // Set default filter values
    this.setDefaultFilter(defaultFilter)

    // Warns right-panel-filter-view (mobile) that default values have been applied
    this.communicateChange()
  },
  beforeDestroy () {
    // this.$bus.emit('right-panel-clear-feature', 'filter-messages')
    this.$bus.off('service:change')
    this.$bus.off('filter-update-fields')
    this.$bus.off('filter-apply-filter-' + this.randomId)
    this.$bus.off('filter-save-filter')
    this.$bus.off('filter-delete-filter')
    this.$bus.off('filter-update-fields')
  },
  methods: {
    allStatus () {
      let nbStatus = 0
      let nbStatusChecked = 0
      for (const status in this.statusList) {
        if (this.showStatus(this.statusList[status])) {
          let isInCategory = false
          for (const category in this.arrayStatusList) {
            if (this.arrayStatusList[category].includes(this.statusList[status].id)) {
              isInCategory = true
              break
            }
          }
          if (isInCategory) {
            nbStatus++
            if (this.statusList[status].state) {
              nbStatusChecked++
            }
          }
        }
      }
      return nbStatus === nbStatusChecked
    },
    applyFilter (mode = 1, filterConditions = {}) {
      let that = this
      clearTimeout(this.timer) //Annule le delayApplyFilter
      if (this.modeFilter !== mode) {
        //this.clearFilterFields()
        this.modeFilter = mode
        switch (this.modeFilter) {
          case 0:
            this.filterTypeGet = 'draft'
            break
          case 1:
            this.filterTypeGet = 'list'
            break
          case 2:
            this.filterTypeGet = 'group'
            break
          default:
            this.filterTypeGet = 'list'
            break
        }
        let actualService = this.getActualService()
        var defaultFilter = {}
        switch (this.filterTypeGet) {
          case 'details':
            defaultFilter = actualService.filterDetails.getDefaultFilter()
            break
          case 'draft':
            defaultFilter = actualService.filterDraft.getDefaultFilter()
            break
          case 'group':
            defaultFilter = actualService.filterGroup.getDefaultFilter()
            break
          case 'list':
            defaultFilter = actualService.filter.getDefaultFilter()
            break
          default:
            defaultFilter = actualService.filter.getDefaultFilter()
            break
        }
        // Set default filter values
        this.setDefaultFilter(defaultFilter)
      }

      let actualService = this.getActualService()
      let actualFilter
      switch (this.filterTypeGet) {
        case 'details':
          actualFilter = actualService.filterDetails
          break
        case 'draft':
          actualFilter = actualService.filterDraft
          break
        case 'group':
          actualFilter = actualService.filterGroup
          break
        case 'list':
          actualFilter = actualService.filter
          break
        default:
          actualFilter = actualService.filter
          break
      }
      actualFilter.cleanFilterCondition()

      let statusArray = []
      for (let property in this.statusList) {
        let status = that.statusList[property]
        if(this.serviceId === '1') {
          if(status.state === 1) {
            statusArray.push(status.id)
          }
        }
        else {
          actualFilter[property] = status.state
        }
      }

      if(this.serviceId === '1') {
        actualFilter.status = statusArray.join(',')
      }
      else {
        actualFilter.status = this.status
      }

      let typeMessageArray = []
      for (let property in this.msgTypeList) {
        let type = that.msgTypeList[property]
        if(type.state === 1) {
          typeMessageArray.push(type.id)
        }
      }

      let typeFeatureArray = []
      for (let property in this.featureList) {
        let type = that.featureList[property]
        if(type.state === 1) {
          typeFeatureArray.push(type.id)
        }
      }

      actualFilter.featureType = typeFeatureArray.join(',')
      if(this.serviceId === '1') {
        actualFilter.messageType = typeMessageArray.join(',')
      }
      else {
        actualFilter.messageType = this.msgType
      }

      if (this.mode === 4) {
        filterConditions.orphelan = '1'
      }

      this.dateBeginError = this.dateBegin && !formatDateTime(this.dateBegin)
      this.creationDateBeginError = this.creationDateBegin && !formatDateTime(this.creationDateBegin)
      this.dateEndError = this.dateEnd && !formatDateTime(this.dateEnd)
      this.creationDateEndError = this.creationDateEnd && !formatDateTime(this.creationDateEnd)
      this.requestedPaymentDateBeginError = this.requestedPaymentDateBegin && !formatDateTime(this.requestedPaymentDateBegin)
      this.requestedPaymentDateEndError = this.requestedPaymentDateEnd && !formatDateTime(this.requestedPaymentDateEnd)
      this.expirationDateBeginError = this.expirationDateBegin && !formatDateTime(this.expirationDateBegin)
      this.expirationDateEndError = this.expirationDateEnd && !formatDateTime(this.expirationDateEnd)
      if (this.dateBeginError || this.dateEndError
        || this.creationDateBeginError || this.creationDateEndError
        || this.requestedPaymentDateBeginError || this.requestedPaymentDateEndError) {
        return
      }
      actualFilter.dateBegin = formatDateTime(this.dateBegin)
      actualFilter.dateEnd = formatDateTime(this.dateEnd)
      actualFilter.creationDateBegin = formatDateTime(this.creationDateBegin)
      actualFilter.creationDateEnd = formatDateTime(this.creationDateEnd)
      actualFilter.requestedPaymentDateBegin = formatDateTime(this.requestedPaymentDateBegin)
      actualFilter.requestedPaymentDateEnd = formatDateTime(this.requestedPaymentDateEnd)
      actualFilter.expirationDateBegin = formatDateTime(this.expirationDateBegin)
      actualFilter.expirationDateEnd = formatDateTime(this.expirationDateEnd)
      actualFilter.initParty = this.initParty
      actualFilter.SocialReason = this.filterSupplierName
      actualFilter.creditorOrDebtorName = this.cdtrOrDbtrNm
      actualFilter.debtorId = this.debtorId
      actualFilter.endToEndId = this.endToEndId
      actualFilter.reason = this.reason
      actualFilter.originalReason = this.originalReason
      actualFilter.modifiedReason = this.modifiedReason
      actualFilter.reasonEditable = this.reasonEditable
      actualFilter.typeAction = this.typeAction
      actualFilter.user = this.user
      actualFilter.documentType = this.filterDocumentType
      actualFilter.siren = this.filterSiren
      actualFilter.sellerName = this.filterSupplierName
      actualFilter.modeFilter = mode
      actualFilter.debtorIdProvider = this.debtorIdProvider
      actualFilter.debtorName = this.debtorName
      actualFilter.debtorNameProvider = this.debtorNameProvider
      actualFilter.ultimateDebtorBEI = this.ultimateDebtorBEI
      actualFilter.creditorIdProvider = this.creditorIdProvider
      actualFilter.creditorAccount = this.creditorAccount
      actualFilter.creditorName = this.creditorName
      actualFilter.creditorNameProvider = this.creditorNameProvider
      actualFilter.ultimateCreditorBEI = this.ultimateCreditorBEI
      actualFilter.amount = this.amount
      actualFilter.amountEditable = this.amountEditable
      actualFilter.amountOrig = this.amountOrig
      actualFilter.amountModif = this.amountModif
      actualFilter.currency = this.currency
      actualFilter.msgId = this.msgId
      actualFilter.direction = this.role !== 2 ? this.role : undefined
      actualFilter.standard = this.normId
      actualFilter.section = this.section

      for (let propertyCustom in filterConditions) {
        actualFilter[propertyCustom] = filterConditions[propertyCustom]
      }

      if (this.serviceId === '1') {
        Object.keys(actualFilter).forEach(filterName => {
          if (filterName.includes('status') && filterName !== 'status') {
            delete actualFilter[filterName]
          }
        })
      }

      this.$emit('applyFilter', actualFilter)
    },
    changeFeatureFilters () {
      let norm = this.$engine.user.getUserNorm()
      this.featureList = _.cloneDeep(this.featureListFull)
      if (norm === '1') {
        delete this.featureList.RTPI010
        delete this.featureList.RTPI011
      } else if (norm === '2') {
        delete this.featureList.RTPI005
        delete this.featureList.RTPI006
        delete this.featureList.RTPI009
      } else if (norm === '3') {
        delete this.featureList.RTPI002
        delete this.featureList.RTPI003
        delete this.featureList.RTPI004
        delete this.featureList.RTPI005
        delete this.featureList.RTPI006
        delete this.featureList.RTPI008
        delete this.featureList.RTPI009
      }
    },
    checkAllMsgType () {
      for (const msgType in this.msgTypeList) {
        this.msgTypeList[msgType].state = this.msgTypeAll ? 1 : 0
      }
    },
    checkAllFeature () {
      for (const feature in this.featureList) {
        this.featureList[feature].state = this.featureAll ? 1 : 0
      }
    },
    checkAllStatus () {
      let allStatusRes = this.allStatus()
      for (const status in this.statusList) {
        if (this.showStatus(this.statusList[status])) {
          this.statusList[status].state = allStatusRes ? 0 : 1
        }
      }
    },
    clearFilterFields () {
      let that = this

      this.statusList = {
        statusIssued: {
          label: statusLabel(this.$i18n, Status.RTP_ISSUED),
          id: '1',
          icon: '',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusWaiting: {
          label: statusLabel(this.$i18n, Status.RTP_WAITING),
          id: '1',
          icon: statusIcon(Status.WAITING),
          state: 0,
          filterName: 'list',
          services: ['2', '6']
        },
        statusExpired: {
          label: statusLabel(this.$i18n, Status.RTP_EXPIRED),
          id: '12',
          icon: statusIcon(Status.EXPIRED),
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusExpiring: {
          id: '120',
          state: 0,
          filterName: 'list',
          services: ['1']
        },
        statusCanceled: {
          id: '14',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusBeingCanceled: {
          id: '13',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusCancellationRejected: {
          id: '15',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusRequestReceived: {
          label: statusLabel(this.$i18n, Status.RTP_RECEIVED),
          id: '5',
          icon: statusIcon(Status.RECEIVED),
          state: 1,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestAccepted: {
          label: statusLabel(this.$i18n, Status.RTP_ACCEPTED),
          id: '10',
          icon: statusIcon(Status.ACCEPTED),
          state: 1,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestRevoked: {
          label: statusLabel(this.$i18n, Status.RTP_REVOKED),
          id: '11',
          icon: statusIcon(Status.REVOKED),
          state: 1,
          filterName: 'list',
          services: ['1', '2', '6']
        },
        statusRequestModified: {
          label: statusLabel(this.$i18n, Status.RTP_MODIFIED),
          id: '9',
          icon: statusIcon(Status.MODIFIED),
          state: 1,
          filterName: 'list',
          services: ['1']
        },
         statusInstallmentPaid: {
           label: statusLabel(this.$i18n, Status.RTP_INSTALLMENT_PAID),
           id:'30',
           icon: statusIcon(Status.INSTALLMENT_PAID),
           state: 0,
           filterName: 'list',
           services: ['1']
         },
         statusMessageFormatIncorrect: {
           label: statusLabel(this.$i18n, Status.RTP_MSG_FORMAT_INCORRECT),
           id: '7',
           icon: statusIcon(Status.REJECTED),
           state: 1,
           filterName: 'list',
           services: ['1']
         },
        statusRejected: {
          label: statusLabel(this.$i18n, Status.REJECTED),
          id: '6',
          icon: statusIcon(Status.REJECTED),
          state: 1,
          filterName: 'list',
          services: ['1', '2']
        },
        statusPaymentWaitingInitiation: {
          id: '19',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentInitiated: {
          id: '20',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentRejected: {
          id: '21',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentSettled: {
          id: '22',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentPartiallySettled: {
          id: '23',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentValidated: {
          id: '24',
          state: 1,
          filterName: 'list',
          services: ['1']
        },
        statusPaymentRefused: {
          id: '25',
          state: 1,
          filterName: 'list',
          services: ['1']
        }
      }

      for (let property in that.msgTypeList) {
        that.msgTypeList[property].state = 1
      }

      if (this.modeFilter === 2 && this.serviceId === services.DOCUMENTSERVICE) {
        that.statusList.statusDocRejected.state = 1
        that.statusList.statusDocValidated.state = 1
      }

      this.dateBegin = ''
      this.dateEnd = ''
      this.creationDateBegin = ''
      this.creationDateEnd = ''
      this.requestedPaymentDateBegin = ''
      this.requestedPaymentDateEnd = ''
      this.expirationDateBegin = ''
      this.expirationDateEnd = ''
      this.status = ''
      this.initParty = ''
      this.featureAll = true
      this.msgTypeAll = true
      this.cdtrOrDbtrNm = ''
      this.debtorId = ''
      this.debtorIdProvider = ''
      this.debtorName = ''
      this.debtorNameProvider = ''
      this.ultimateDebtorBEI = ''
      this.creditorIdProvider = ''
      this.creditorAccount = ''
      this.creditorName =''
      this.creditorNameProvider = ''
      this.ultimateCreditorBEI
      this.endToEndId = ''
      this.msgId = ''
      this.normId = ''
      this.reason = ''
      this.originalReason = ''
      this.modifiedReason = ''
      this.reasonEditable = ''
      this.amount = ''
      this.amountEditable = ''
      this.amountOrig = ''
      this.amountModif = ''
      this.currency = ''
      this.typeAction = ''
      this.user = ''
      this.filterDocumentType = ''
      this.filterSiren = ''
      this.filterSupplierName = ''
      this.filterSupplierId = ''
      if (this.mode === 5) {
        this.dateBegin = moment().format('01/MM/YYYY 00:00:00')
      }
      this.changeFeatureFilters()
      this.communicateChange()
      clearTimeout(this.timer)
      this.applyFilter(this.modeFilter)
    },
    deleteFilter () {
      let actualService = this.getActualService()
      switch (this.filterTypeGet) {
        case 'details':
          actualService.filterDetails.saveDefaultFilter({})
          break
        case 'draft':
          actualService.filterDraft.saveDefaultFilter({})
          break
        case 'group':
          actualService.filterGroup.saveDefaultFilter({})
          break
        case 'list':
          actualService.filter.saveDefaultFilter({})
          break
        default:
          actualService.filter.saveDefaultFilter({})
          break
      }
      this.hasDefaultFilter = false
      this.$f7.modal({
        title: 'Filtre supprimé',
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    delayApplyFilter (modeFilter) {
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.applyFilter(modeFilter)
      }, 1500)
    },
    loadSavedFiltersInFields () {
      let savedFilters = this.$engine.services.payments.filter

      if (savedFilters.dateBegin) {
        this.dateBegin = moment(savedFilters.dateBegin).format('DD/MM/YYYY HH:mm:ss')
      }
      if (savedFilters.creationDateBegin) {
        this.creationDateBegin = moment(savedFilters.creationDateBegin).format('DD/MM/YYYY HH:mm:ss')
      }
      if (savedFilters.requestedPaymentDateBegin) {
        this.creationDateBegin = moment(savedFilters.creationDateBegin).format('DD/MM/YYYY HH:mm:ss')
      }
      if (savedFilters.expirationDateBegin) {
        this.expirationDateBegin = moment(savedFilters.expirationDateBegin).format('DD/MM/YYYY HH:mm:ss')
      }
      if (savedFilters.dateEnd) {
        this.dateEnd = moment(savedFilters.dateEnd).format('DD/MM/YYYY HH:mm:ss')
      }
      if (savedFilters.creationDateEnd) {
        this.creationDateEnd = moment(savedFilters.creationDateEnd).format('DD/MM/YYYY HH:mm:ss')
      }
      if (savedFilters.requestedPaymentDateEnd) {
        this.requestedPaymentDateEnd = moment(savedFilters.requestedPaymentDateEnd).format('DD/MM/YYYY HH:mm:ss')
      }
      if (savedFilters.expirationDateEnd) {
        this.expirationDateEnd = moment(savedFilters.expirationDateEnd).format('DD/MM/YYYY HH:mm:ss')
      }
      let savedStatusArray = savedFilters.status ? savedFilters.status.split(",") : []
      let tempStatusList = this.statusList
      Object.values(tempStatusList).forEach((stat) => {
        stat.state = 0
        if (stat.services.includes(this.$engine.user.currentService.id.toString())) {
          savedStatusArray.forEach((savedStat) => {
            if (stat.id === savedStat) {
              stat.state = 1
            }
          })
        }
      })
      let savedMsgTypeArray = savedFilters.messageType.split(",")
      let tempMsgTypeList = this.msgTypeList
      Object.values(tempMsgTypeList).forEach((type) => {
        savedMsgTypeArray.forEach((savedType) => {
          if (type.id === savedType) {
            type.state = 1
          }
        })
      })

      this.statusList = _.cloneDeep(tempStatusList)
      this.msgTypeList = _.cloneDeep(tempMsgTypeList)
      this.initParty = savedFilters.initParty
      this.cdtrOrDbtrNm = savedFilters.creditorOrDebtorName
      this.debtorId = savedFilters.debtorId
      this.debtorIdProvider = savedFilters.debtorIdProvider
      this.debtorName = savedFilters.debtorName
      this.debtorNameProvider = savedFilters.debtorNameProvider
      this.ultimateDebtorBEI = savedFilters.ultimateDebtorBEI
      this.creditorIdProvider = savedFilters.creditorIdProvider
      this.creditorAccount = savedFilters.creditorAccount
      this.creditorName = savedFilters.creditorName
      this.creditorNameProvider = savedFilters.creditorNameProvider
      this.ultimateCreditorBEI = savedFilters.ultimateCreditorBEI
      this.endToEndId = savedFilters.endToEndId
      this.msgId = savedFilters.msgId
      this.amount = savedFilters.amount
      this.amountEditable = savedFilters.amountEditable
      this.amountOrig = savedFilters.amountOrig
      this.amountModif = savedFilters.amountModif
      this.currency = savedFilters.currency
      this.reason = savedFilters.reason
      this.originalReason = savedFilters.originalReason
      this.modifiedReason = savedFilters.modifiedReason
      this.reasonEditable = savedFilters.reasonEditable
      this.typeAction = savedFilters.typeAction
      this.user = savedFilters.user
      this.filterDocumentType = savedFilters.documentType
      this.filterSiren = savedFilters.siren
      this.filterSupplierName = savedFilters.filterSupplierName
      this.filterSupplierId = savedFilters.filterSupplierId
      this.role = savedFilters.direction || 2
    },
    saveDefaultFilter () {
      let that = this

      let actualService = this.getActualService()

      let defaultFilter = {
        dateBegin: this.dateBegin,
        dateEnd: this.dateEnd,
        creationDateBegin: this.creationDateBegin,
        creationDateEnd: this.creationDateEnd,
        requestedPaymentDateBegin: this.requestedPaymentDateBegin,
        requestedPaymentDateEnd: this.requestedPaymentDateEnd,
        expirationDateBegin: this.expirationDateBegin,
        expirationDateEnd: this.expirationDateBegin,
        Status: this.status,
        cdtrOrDbtrNm: this.cdtrOrDbtrNm,
        debtorId: this.debtorId,
        debtorIdProvider: this.debtorIdProvider,
        debtorName: this.debtorName,
        debtorNameProvider: this.debtorNameProvider,
        ultimateDebtorBEI: this.ultimateDebtorBEI,
        creditorIdProvider: this.creditorIdProvider,
        creditorAccount: this.creditorAccount,
        creditorName:  this.creditorName,
        creditorNameProvider: this.creditorNameProvider,
        ultimateCreditorBEI: this.ultimateCreditorBEI,
        endToEndId: this.endToEndId,
        initParty: this.initParty,
        msgId: this.msgId,
        amount: this.amount,
        amountEditable: this.amountEditable,
        amountOrig: this.amountOrig,
        amountModif: this.amountModif,
        currency: this.currency,
        reason: this.reason,
        originalReason: this.originalReason,
        modifiedReason: this.modifiedReason,
        reasonEditable: this.reasonEditable,
        typeAction: this.typeAction,
        user: this.user,
        filterDocumentType: this.filterDocumentType,
        filterSiren: this.filterSiren,
        filterSupplierName: this.filterSupplierName,
        filterSupplierId: this.filterSupplierId
      }

      for (const property in this.statusList) {
        let status = that.statusList[property]
        defaultFilter[property] = status.state
      }

      for (const property in this.msgTypeList) {
        let type = that.msgTypeList[property]
        defaultFilter[property] = type.state
      }

      switch (this.filterTypeGet) {
        case 'details':
          actualService.filterDetails.saveDefaultFilter(defaultFilter)
          break
        case 'draft':
          actualService.filterDraft.saveDefaultFilter(defaultFilter)
          break
        case 'group':
          actualService.filterGroup.saveDefaultFilter(defaultFilter)
          break
        case 'list':
          actualService.filter.saveDefaultFilter(defaultFilter)
          break
        default:
          actualService.filter.saveDefaultFilter(defaultFilter)
          break
      }

      if (this.hasInputFilter) {
        this.hasDefaultFilter = true
      }

      that.$f7.modal({
        title: this.$i18n.t('filter.dflt_fltr_svd'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    getActualService () {
      if (this.isHistory) {
        return this.$engine.history
      } else if (this.isVerifications) {
        return this.$engine.services.verifications
      }
      let serviceName = {
        '1': this.$engine.services.payments,
        '2': this.$engine.services.directDebit,
        '6': this.$engine.services.directPayments,
        '7': this.$engine.services.businessDocuments,
        '8': this.$engine.services.suppliers
      }
      return serviceName[this.serviceId]
    },
    featureChange () {
      let nbChecked = 0
      for (const feature in this.featureList) {
        if (this.featureList[feature].state) {
          nbChecked++
        }
      }
      this.featureAll = Object.keys(this.featureList).length === nbChecked
    },
    hasRight (right) {
      if(this.$engine.rights.rightIs(right, true) === true) {
        return true
      } else {
        return false
      }
    },
    msgTypeChange () {
      let nbChecked = 0
      for (const msgType in this.msgTypeList) {
        if (this.msgTypeList[msgType].state) {
          nbChecked++
        }
      }
      this.msgTypeAll = Object.keys(this.msgTypeList).length === nbChecked
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    setDefaultFilter (defaultFilter) {
      for (const property in defaultFilter) {
        if (this.statusList[property] !== undefined) {
          // Set filter status values
          this.statusList[property].state = defaultFilter[property]
          if (defaultFilter[property] === 1) {
            this.hasDefaultFilter = true
          }
        } else if (this.msgTypeList[property] !== undefined) {
          // Set filter message type (orphan) values
          this.msgTypeList[property].state = defaultFilter[property]
          if (defaultFilter[property] === 1) {
            this.hasDefaultFilter = true
          }
        } else {
          // Set filter other values
          if (property !== 'modeFilter') {
            this[property] = defaultFilter[property]
            if (this[property]) {
              this.hasDefaultFilter = true
            }
          }
        }
      }
    },
    showFilterDateBegin () {
      return true //!(this.filterType === 'list' && this.serviceId === '8')
    },
    showFilterCreationDateBegin () {
      return true
    },
    showFilterRequestedPaymentDateBegin () {
      return true
    },
    showFilterExpirationDateBegin () {
      return true
    },
    showFilterDateEnd () {
      return true // !(this.filterType === 'list' && this.serviceId === '8')
    },
    showFilterCreationDateEnd () {
      return true
    },
    showFilterRequestedPaymentDateEnd () {
      return true
    },
    showFilterExpirationDateEnd () {
      return true
    },
    showFilterContactName () {
      if (((this.filterType === 'list' && this.serviceId !== '7' && this.serviceId !== '8') ||
          (this.filterType === 'details' && (this.serviceId === '7' || this.serviceId === '8') && this.mode !== 2) ||
          this.filterType === 'draft') &&
          !this.isHistory && !this.isVerifications && ![3, 4, 5].includes(this.mode)) {
        return true
      }
      return false
    },
    showFilterDebtorId () {
      if (this.filterType === 'list' && this.mode === 1) {
        return true
      }
      return false
    },
    showFilterDoctype () {
      return this.mode === 2 &&
        this.serviceId === services.DOCUMENTSERVICE
    },
    showFilterEndToEndId () {
      return this.isHistory || [1,3].includes(this.mode)
    },
    showFilterReason () {
      return this.serviceId !== '7' && this.serviceId !== '8' && !this.isHistory && !this.isVerifications && ![3, 4, 5].includes(this.mode)
    },
    showFilterReasonEditable () {
      return this.mode === 1
    },
    showFilterOriginalReason () {
      return this.mode === 1
    },
    showFilterModifiedReason () {
      return this.mode === 1
    },
    showButtonCreateSupplier () {
      return this.buttonCreateSupplier
    },
    showButtonCreateVerify () {
      return this.buttonCreateVerify
    },
    showButtonImportLot () {
      // Service RTP import lot identifiant?
      return false
    },
    showFilterNorm () {
      let currentRights = this.$engine.rights.getAll()
      let rightNormFound = false
      if (currentRights) {
        Object.entries(currentRights).forEach((right) => {
          if (right[0].includes('_srtp') || right[0].includes('_hrtp') || right[0].includes('_psd2')) {
            rightNormFound = true
          }
        })
      }
      return [1,2, 3, 4, 5].includes(this.mode) && this.serviceId != '8' &&
      (this.$engine.rights.rightIs('super_admin', true) || !rightNormFound)
    },
    showFilterStatus () {
      return ![2, 3, 4, 5].includes(this.mode) &&
        !this.isHistory && !this.isVerifications &&
        this.serviceId !== '8'
    },
    showFilterStatusVerif () {
      return this.mode !== 2 &&
        this.isVerifications
    },
    showFilterStatusKYC () {
      return this.mode !== 2 && this.serviceId === services.SUPPLIERS &&
        !this.isHistory && !this.isVerifications
    },
    showFilterSupplierId () {
      return this.filterType === 'list' &&
        this.serviceId === services.SUPPLIERS
    },
    showFilterSupplierName () {
      if ((this.filterType === 'list' && this.serviceId === services.SUPPLIERS) ||
        (this.filterType === 'details' && this.serviceId === services.DOCUMENTSERVICE && this.mode === 2)) {
        return true
      }
      return false
    },
    showFilterSupplierSIREN () {
      return this.filterType === 'list' &&
        this.serviceId === services.SUPPLIERS
    },
    showFilterTypeAction () {
      return this.isHistory
    },
    showFilterUser () {
      return this.isHistory
    },
    showListDraftPanel () {
      return this.serviceId === services.DIRECTPAYMENTS
    },
    showListGroupPanel () {
      return this.serviceId === services.PAYMENTS &&
        !this.isHistory
    },
    showStatus (status) {
      return status.services.includes(this.$engine.user.currentService.id.toString()) &&
        status.filterName === this.filterTypeGet
    },
    showFilterAmount () {
      return this.mode === 1
    },
    showFilterAmountEditable () {
      return this.mode === 1
    },
    showFilterAmountOrig () {
      return this.mode === 1
    },
    showFilterAmountModif () {
      return this.mode === 1
    },
    showFilterCurrency () {
      return this.mode === 1
    },
    showFilterDebtorIdProvider () {
      return this.mode === 3 || this.mode === 1
    },
    showFilterDebtorName () {
      return this.mode === 1
    },
    showFilterDebtorNameProvider () {
      return this.mode === 1
    },
    showFilterUltimateDebtorBEI () {
      return this.mode === 1
    },
    showFilterCreditorIdProvider () {
      return this.mode === 3 || this.mode === 1
    },
    showFilterCreditorAccount () {
      return this.mode === 1
    },
    showFilterCreditorName () {
      return this.mode === 1
    },
    showFilterCreditorNameProvider () {
      return this.mode === 1
    },
    showFilterUltimateCreditorBEI () {
      return this.mode === 1
    },
    showFilterInitParty () {
      return this.mode === 4
    },
    showFilterMsgId () {
      return this.mode === 3 || (this.mode === 1 && this.isBackOffice)
    },
    showFilterMsgIdOrphan () {
      return this.mode === 4
    },
    showFilterMsgType () {
      return this.mode === 4
    },
    showFilterFeature () {
      return this.mode === 5
    }
  }
}
</script>
